import { EventBus } from './eventBus';
import { EventBusInitOptions, EventBusManager } from './eventBustManager';

export { EventBus } from './eventBus';
export type { EventHandler, Unsubscribe } from './eventBus';

export { EventFactory } from './eventFactory/eventFactory';

export { PostMessageAdapter } from './adapters/postMessageAdapter';
export { ExplicitBridgeAdapter } from './adapters/explicitBridgeAdapter';
export type { EventBusAdapter } from './adapters/eventBusAdapter';

let defaultEventBus: EventBus | null = null;

export function initEventBus(options: EventBusInitOptions): EventBus {
  if (!options.adapters || !Array.isArray(options.adapters)) {
    throw new Error(
      '[EventBus] Adapters must be explicitly provided as an array of instances. Example: adapters: [PostMessageAdapter.factory()]',
    );
  }

  const enableLogging = options.enableLogging ?? false;

  const manager = EventBusManager.initialize({
    enableLogging,
    adapters: options.adapters,
  });

  defaultEventBus = manager.getEventBus();

  return defaultEventBus;
}

export const eventBus = new Proxy<EventBus>({} as EventBus, {
  get: (target, prop) => {
    if (!defaultEventBus) {
      console.error('[EventBus] Not initialized');
      throw new Error('[EventBus] Not initialized');
    }
    return (defaultEventBus as any)[prop];
  },
});
